import { render, staticRenderFns } from "./PreviewDocumentWidget.vue?vue&type=template&id=3f0ad627&scoped=true&"
import script from "./PreviewDocumentWidget.vue?vue&type=script&lang=js&"
export * from "./PreviewDocumentWidget.vue?vue&type=script&lang=js&"
import style0 from "./PreviewDocumentWidget.vue?vue&type=style&index=0&id=3f0ad627&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0ad627",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f0ad627')) {
      api.createRecord('3f0ad627', component.options)
    } else {
      api.reload('3f0ad627', component.options)
    }
    module.hot.accept("./PreviewDocumentWidget.vue?vue&type=template&id=3f0ad627&scoped=true&", function () {
      api.rerender('3f0ad627', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/PreviewDocumentWidget.vue"
export default component.exports